export const MODULE_KEYS = [
  'teachers',
  'calendar',
  'thai-events',
  'announcements',
  'communications',
  'weekly-menus',
  'contact-inquiries',
  'tour-requests',
  'leave-requests',
  'immigration-compliance',
  'sand-dollars-config',
  'student-management',
  'student-credentials',
  'parents',
  'sst',
  'medical',
  'school-years',
  'timetable',
  'statistics',
  'users',
  'settings',
  'audit-log',
  'cafeteria',
  'shop',
  'it-support',
  'bookings',
  'edp',
  'report-cards',
  'conferences',
  'billing',
  'sparky',
] as const;

export type ModuleKey = (typeof MODULE_KEYS)[number];

/**
 * Modules a teacher-role account can be granted, in addition to their fixed
 * role-based access. Deliberately a short allowlist, not "every module minus a
 * few" — most modules (users, settings, audit-log, school-years, ...) are
 * meaningless for a teacher account. Enforced identically on the backend
 * (AdminUsersService) so a crafted request can't grant a teacher anything else.
 */
export const TEACHER_GRANTABLE_MODULES: ModuleKey[] = ['student-credentials', 'sst', 'sparky'];
